import { Typography } from "@packages/ds";
import styled from "styled-components";

import { Divider } from "ds/Accordion";
import { CloseButton as BaseCloseButton } from "ds/Button";

export const Wrapper = styled.section`
  position: relative;
  margin: 24px 0 42px 0;
  padding: 32px;
  background-color: var(--section-snow-background-color, var(--snow));
  border-radius: 2px;

  p {
    margin: 0;
    font-size: 14px;
    line-height: 24px;
    color: var(--section-slate-color, var(--slate));
  }
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 8px;
`;

export const CloseButton = styled(BaseCloseButton)`
  right: 24px;
  position: absolute;
  top: 24px;
`;

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`;

export const ListContainer = styled.div`
  margin-top: 24px;
`;

export const ListDivider = styled(Divider)`
  margin: 24px 0;
`;

export const CostNotice = styled.div`
  margin-top: 18px;
  ${Typography.BodyText} {
    font-size: 12px;
    font-weight: 600;
    color: var(--color-platform-grey-800);
  }
`;
